/* import __COLOCATED_TEMPLATE__ from './prism-segmented-selector.hbs'; */
import Component from '@ember/component';
export default Component.extend({
  tagName: '',
  selectedValue: null,
  onChange() {},
  updateSelection(value) {
    this.set('selectedValue', value);
    this.onChange(value);
  }
});